export const adminFunc = [
  "KHBB", // 客户报备
  "KHBBCD", // 客户管理(客户报备)
  "KHFRGH", // 放入公海
  "GGGJZT", // 更改跟进状态
  "KHXJ", // 客户新建
  "KHSC", // 客户删除
  "KHCC", // 客户查重(报备查询)

  "KHGH", // 客户公海
  "GHFP", // 公海分配
  "GHDC", // 公海导出
  "GHSC", // 公海删除
  "GHXZMB", // 公海下载模板
  "GHKHDR", // 公海导入客户（批量导入）

  "FJKH", // 附近客户

  "LXRGL", // 联系人管理
  "LXRGLCD", // 联系人管理
  "LXRXZ", // 联系人新增
  "LXRBJ", // 联系人编辑
  "LXRSC", //联系人删除

  "HTGL", //合同管理
  "HTGLCD", //合同管理菜单
  "HTXZ", //合同新建
  "HTXG", //合同修改
  "HTSC", //合同删除
  "HTSP", //合同审批
  
  "HTJHXZ", //新增回款计划
  "HTJHBJ", //编辑回款计划
  "HTJHSC", //删除回款计划
  
  "HTHKSPCD", //回款审核菜单
  "HTXJHK", //新建回款
  "HTBJHK", //编辑回款
  "HTSCHK", //删除回款
  "HTHKSP", //合同回款审批

  "HTSCFJ", //上传附件
  "HTXZFJ", //下载附件
  "HTDEFJ", //删除附件

  "XTSZ", // 系统设置
  "XTSZCD", // 系统设置
  "QXSZ", // 权限设置
  "GZSZ", // 规则设置
  "ZDGL", // 字典管理

  "ZZJG", // 组织架构
  "TBZZJG", // 同步组织架构
  "FPJS", // 分配角色
  "JSGL", // 角色管理
  "XZJS", // 新增角色
  "XGJS", // 修改角色
  "SCJS", // 删除角色
];

// export const getRouteFunKey = (routes) => {
//   let keysArr = [];
//   routes.forEach((r) => {
//     if (r.meta && r.meta.funcKey) keysArr.push(r.meta.funcKey);
//     if (r.children) {
//       let arr = this.getFunKey(r.children);
//       keysArr.push(...arr);
//     }
//   });
//   return keysArr;
// };
